import { useQuery } from "react-query"
import { getPerformersForPost } from "@requests/performers"

export function usePerformersForPost(
  bandId: number,
  postId: number,
  enabled: boolean,
) {
  return useQuery(
    ["performers_for_post", bandId, postId],
    () => getPerformersForPost(bandId, postId),
    { enabled },
  )
}
